import { calculateBusinessDays } from '@parallel-fluidics/shared/shipping';

export const extractNumericValue = (value) => {
  if (value == null || value === '') return NaN;
  return typeof value === 'number'
    ? value
    : parseFloat(String(value).replace(/[^\d.-]+/g, ''));
};

export const formatCurrency = (value) => {
  if (value === '') return '';
  const numberValue = extractNumericValue(value);
  if (Number.isNaN(numberValue)) return '';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(numberValue);
};

export const incrementString = (str) => {
  if (!str) return '';
  const prefix = str.match(/[^\d]+/)?.[0] || ''; // Non-digit prefix (e.g., 'C')
  const numberPart = str.match(/\d+/)[0]; // Digit part (e.g., '0011')

  // Increment the numeric part and pad with leading zeros
  const incrementedNumber = String(Number(numberPart) + 1).padStart(numberPart.length, '0');

  // Return the combined result
  return prefix + incrementedNumber;
};

export const getPartsWithLatestRevision = (parts) => {
  // clean revision, for same partId, only keep the latest revision
  const partsMap = {};
  parts.forEach((part) => {
    if (!partsMap[part.partId] || partsMap[part.partId].revision < part.revision) {
      partsMap[part.partId] = part;
    }
  });

  return Object.values(partsMap);
};

export const getShipDateText = (targetShipDate, shipDateActual = null, goal = 0) => {
  const daysUntilShip = Math.ceil((new Date(`${shipDateActual || targetShipDate} 00:00:00`) - new Date()) / (1000 * 60 * 60 * 24));
  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  const fromNow = rtf.format(daysUntilShip, 'day');
  let baseTextPrefix;
  if (shipDateActual) {
    baseTextPrefix = 'Shipped';
  } else if (daysUntilShip < 0) {
    baseTextPrefix = 'Scheduled to ship';
  } else {
    baseTextPrefix = 'Ships';
  }
  if (goal > 0) {
    baseTextPrefix += ` ${goal} parts`;
  }

  const businessDaysUntilShip = calculateBusinessDays(targetShipDate);
  const baseText = `${baseTextPrefix} ${fromNow}${(businessDaysUntilShip > 0 && daysUntilShip !== businessDaysUntilShip) ? ` (${businessDaysUntilShip} business days)` : ''}`;
  if (shipDateActual && shipDateActual !== targetShipDate) {
    const diffInDays = Math.ceil((new Date(`${targetShipDate} 00:00:00`) - new Date(`${shipDateActual} 00:00:00`)) / (1000 * 60 * 60 * 24));
    return `${baseText} (${Math.abs(diffInDays)} days ${diffInDays > 0 ? 'early' : 'late'})`;
  }
  return baseText;
};

export const getShippingEstimateText = (rateStr, count) => {
  if (!rateStr || !count) return '';
  return `We estimated ${rateStr} for ${count} packages`;
};

export default formatCurrency;
